import React, { useEffect, useState } from "react";
import classNames from "classnames";
import { useLayoutStore } from "~/store";
import { Heading } from "~/components";
import styles from "./NotFoundPage.module.css";
import logo from "../../assets/images/marriott-logo.png";
import { sendPageViewWhenConsentReady } from "../../utils/adobeDataLayerUtils";
import {
  DEFAULT_NOT_FOUND_PAGE_NAME,
  REDIRECT_DELAY_MS,
  REDIRECT_URL,
  formatRedirectCountdown,
  getInitialSecondsLeft,
  shouldRedirectNow,
  tickSecondsLeft,
} from "./notFoundRedirect";

export const NotFoundPage = ({
  trackValue = "Not Found Page|Home Button",
  pageName = DEFAULT_NOT_FOUND_PAGE_NAME,
  autoRedirect = false,
}) => {
  const { isResetting, setShowHeader, setContentClassName } = useLayoutStore();
  const [secondsLeft, setSecondsLeft] = useState(() =>
    getInitialSecondsLeft(REDIRECT_DELAY_MS),
  );

  useEffect(() => {
    if (isResetting) {
      return;
    }

    setShowHeader(false);
    setContentClassName(styles.container);
  }, [isResetting]);

  useEffect(() => {
    return sendPageViewWhenConsentReady(pageName);
  }, [pageName]);

  useEffect(() => {
    if (!autoRedirect) {
      return undefined;
    }

    const countdownInterval = setInterval(() => {
      setSecondsLeft(tickSecondsLeft);
    }, 1000);

    return () => clearInterval(countdownInterval);
  }, [autoRedirect]);

  useEffect(() => {
    if (!shouldRedirectNow(autoRedirect, secondsLeft)) {
      return;
    }

    window.location.assign(REDIRECT_URL);
  }, [autoRedirect, secondsLeft]);

  return (
    <section className={styles.box}>
      <img alt="Marriott logo" src={logo} className={styles.logo} />
      <Heading
        type="h1"
        text="Whoops! We hit a dead end."
        className={styles.heading}
      />
      <p className={styles.subheader}>
        The page you’re looking for couldn’t be found.
      </p>
      {autoRedirect && (
        <p className={styles.redirectMessage} aria-live="polite">
          {formatRedirectCountdown(secondsLeft)}
        </p>
      )}
      <a
        href={REDIRECT_URL}
        className={classNames(styles.btn, "custom_click_track")}
        data-custom_click_track_value={`${trackValue}|internal`}
      >
        Go Home
      </a>
    </section>
  );
};
